export default __webpack_public_path__ + "static/media/blackmikefill.b7b35d83.svg";